
import { se_3_1of4_PAaA, xyz_3_1of4 } from './SL44000Sprint03TTR'
import { xyz_n_3of4 } from './SL00000Sprint00TTR'
import { list20000Sprint02 } from '../ActivityLists/AL20000Sprint02'
import { list20000Sprint03 } from '../ActivityLists/AL20000Sprint03'

import { breakoutStandard } from './SLSprint00'
import { tUnderConstruction } from './SL00000Sprint00'
import { xyz_n_4of4 } from './SL44000Sprint01TTR'

// Introduction to Computer Science (ICS) sprint 1 values.
const sprint = 3
const activityList = () => { return list20000Sprint03(sprint) }
const activityListPrevious = () => { return list20000Sprint02(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const ics_3_1of4 = () => { return xyz_3_1of4(se_3_1of4_PAaA, ics_3_2of4_PAaA, sprintAndActivityLists) }
const ics_3_2of4_PAaA = {
	'prework':[
		'Complete through activity 6 prior to next class', '',
		'Be prepared for Demos and Retrospectives',
		'Focus on reading “Computer Science Illuminated” The Big Picture and review chapter 1 lecture',
		'Be prepared for “Computer Science Illuminated” The Big Picture Breakout' ],
	'announcements':[
		'Recall that next week is asynchronous remote**' ],
	'agenda':[
		`Sprint ${sprint-1} Demos`,
		`Sprint ${sprint-1} Retrospective`,
		`Breakout for Sprint ${sprint-1} Retrospective`,
		`Sprint ${sprint} Planning Q&A`,
		`Discussion Board ${sprint} as a scrum team`,
		'Prework for Next Class',
		'Lab' ],
}

const ics_3_2of4 = () => { return [ tUnderConstruction ] }

// Session 3 of 4: Tuesday
const breakoutRepresentationName = 'Data Representation'
const breakoutRepresentation = () => { 
	return breakoutStandard(`Breakout: ${breakoutRepresentationName}`, 
		'In this breakout session on Data Representation (reading and lecture) your team will explain:', [
		'Analog and Digital Data',
		'Binary Representation of Numeric Data',
		'Text including ASCII, Unicode, UTF-8, UTF-16 Representations, and PDF',
		'Why do we need to represent some characters in HTML by escaping them?',
		'Photo and Audio Representation Priorities',
		'Video Representation priorities' ])
}
export const ics_3_3of4_PAaA = {
	'prework':[
		`Make your initial Discussion ${sprint} post`,
		'Complete through activity 11 prior to next class', 
		'Focus on reading Engineering Software as a Service Chapter 2 and the associated lecture',
		`Be prepared for Quiz ${sprint}` ],
	'announcements':[
		`Your initial Discussion ${sprint} post was due two days ago`,
		`All sprint ${sprint} activities and assignments due Sunday!`,
		'Reminder that next week is asynchronous remote**' ],
	'agenda':[
		'Sprint Progress Polling',
		`Breakout: ${breakoutRepresentationName}`,
		'Lab',
		'Prework for Next Class',
		`Quiz ${sprint}` ]
}

const ics_3_3of4 = () => { return xyz_n_3of4(ics_3_3of4_PAaA, ics_3_4of4_PAaA, sprintAndActivityLists, breakoutRepresentation) }

// Session 4 of 4: Thursday
/*
export const theHumbleTextFileName = 'The Humble Text File'
export const theHumbleTextFile = () => {
	return bulletListSlide(`${theHumbleTextFileName}`, 
		'Let’s explore Binary Values and the Data Representation of text files including:', [
		'ASCII Text Files', 
		'Unicode',
		'UTF-16 and UTF-8 ',
		'What is a locale',
		'What is received when a US-English ASCII email is sent to a CA-French recipient?'])
}
*/
const ics_3_4of4_PAaA = {
	'prework':[
		'Complete through activity 15 prior to next class', 
		'Be prepared for Lab' ],
	'announcements':[
		`All sprint ${sprint} activities and assignments due Sunday!`,
		'Next week will be asynchronous remote**' ],
	'agenda':[
		`Final sprint ${sprint} activity list and assignment Q&A`,
		'Prework for Next Class', 
		'Lab']
}
const ics_3_4of4 = () => { return xyz_n_4of4(sprint, activityList, ics_3_4of4_PAaA, ics_4_1of4_PAaA.prework ) }

// Sprint 4
// Session 1 of 4: Tuesday
const ics_4_1of4_PAaA = { 
	'prework':[ 
		'Everything is due Sunday!', '',
		`Be prepared for Sprint ${sprint} Planning`,
		`Sprint ${sprint} Planning will be asynchronous and remote` ],
	'announcements':[ 
		`Sprint ${sprint} starts now.` ],
	'agenda':[ 
		`Sprint ${sprint} Planning`,
		`Sprint ${sprint} Planning Breakout`,
		'Review Demos and Demo Schedule',
		'Review Course Structure',
		'Prework for Next Class' ]
}

export const ics_3_slidedeckTTR = [ ics_3_1of4, ics_3_2of4, ics_3_3of4, ics_3_4of4 ]